import React, { useEffect } from "react";

import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import ClearIcon from "@material-ui/icons/Clear";
import ValidateCancelDate, { isEasterDate } from "./ValidateCancelDate";
import { salesChannelIsAmericanas } from "../../../utils/check-sales-channel";
import { StorageUser } from "../../../main/StorageUser";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrBefore)

export default function InlineCancel(props) {
  const { events, origem, dhEntregaEstimada, dataInclusao, dataAlteracao, erpOrigem } =
    props.pedido;

  const lock =
    events && events.length === 1 && events[0].eventName === "CANCELADO"
      ? true
      : false;

  const storageUser = new StorageUser();
  const isAdminInlineCancel = storageUser.allowedByPermission("ADMIN_INLINE_CANCEL");

  const pegueNaLojaHoje = isEasterDate() && origem === "PEGUE_NA_LOJA_HOJE"
    ? { showButton: dayjs(dhEntregaEstimada || dataInclusao).add(1, 'days').isBefore(dayjs()), days: 1 }
    : { showButton: ValidateCancelDate(dhEntregaEstimada || dataInclusao), days: 3 };
  const pegueNaLojaCec = ValidateCancelDate(
    dhEntregaEstimada || dataInclusao,
    true,
    dataAlteracao
  );

  const handleClick = (e) => {
    const { pedido, setState } = props;
    e.preventDefault();
    setState({
      pedido: {
        orderNumber: pedido.numero,
        codigoExterno: pedido.codigoExterno,
        origem: pedido.origem,
        status: pedido.status,
        canalDeVendas: pedido.canalDeVendas,
        loja: pedido.loja,
      },
      modalOpen: true,
    });
  };

  const showCancelButton = isAdminInlineCancel
    ? true
    : ((origem === "PEGUE_NA_LOJA_HOJE" || !salesChannelIsAmericanas(erpOrigem)) && pegueNaLojaHoje.showButton);

  return (
    <>
      {showCancelButton && (
        <Tooltip title={`Pedido está no status há mais de ${pegueNaLojaHoje.days} ${pegueNaLojaHoje.days > 1 ? 'dias' : 'dia'}`}>
          <Button
            disabled={lock}
            variant="contained"
            color="primary"
            size="small"
            startIcon={<ClearIcon />}
            onClick={handleClick}
          >
            Cancelar
          </Button>
        </Tooltip>
      )}

      {pegueNaLojaCec && origem === "PEGUE_NA_LOJA" && (
        <Tooltip title="Pedido está no status há mais de 5 dias">
          <Button
            disabled={lock}
            variant="contained"
            color="primary"
            size="small"
            startIcon={<ClearIcon />}
            onClick={handleClick}
          >
            Solicitar coleta
          </Button>
        </Tooltip>
      )}
    </>
  );
}
